module.exports = __webpack_public_path__ + "img/Fringe_spec_hero.19cb0528.svg";